import { render, staticRenderFns } from "./comment-list.component.vue?vue&type=template&id=6307aa38&scoped=true&"
import script from "./comment-list.component.vue?vue&type=script&lang=js&"
export * from "./comment-list.component.vue?vue&type=script&lang=js&"
import style0 from "./comment-list.component.vue?vue&type=style&index=0&id=6307aa38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6307aa38",
  null
  
)

export default component.exports